module.exports = __webpack_public_path__ + "img/Kollektionen_Smartphone.86bf90f5.jpg";